import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sprout, Award, Lock, Gift } from "lucide-react";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { Card } from "@/components/Layout";

export const PointsCard = () => {
  const { t } = useApp();
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/points").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  const pct = d.next_at ? Math.min(100, Math.round(((d.points - d.level_from) / (d.next_at - d.level_from)) * 100)) : 100;
  return (
    <Card className="space-y-4" data-testid="points-card">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-xs font-bold uppercase tracking-widest text-[#2E9E6B]">{t("Green Points")}</p>
          <p className="font-display text-3xl font-extrabold text-[#0D3B2B]" data-testid="points-value">{d.balance}</p>
          {d.spent > 0 && <p className="text-[11px] text-[#7B968B]">{d.points} {t("earned")} · {d.spent} {t("spent")}</p>}
        </div>
        <div className="text-right">
          <Sprout className="ml-auto h-7 w-7 text-[#2E9E6B]" />
          <p className="font-bold text-[#0D3B2B]" data-testid="points-level">{t(d.level)}</p>
        </div>
      </div>
      <div>
        <div className="h-2.5 overflow-hidden rounded-full bg-[#EAEFEA]"><div className="h-full rounded-full bg-[#2E9E6B] transition-[width] duration-700" style={{ width: `${pct}%` }} /></div>
        <p className="mt-1 text-xs text-[#4A6358]">{d.next_level ? `${d.next_at - d.points} ${t("points to")} ${t(d.next_level)}` : t("Top level reached!")}</p>
      </div>
      <div className="grid grid-cols-4 gap-2" data-testid="badges">
        {d.badges.map((b) => (
          <div key={b.id} className={`flex flex-col items-center rounded-xl p-2 text-center ${b.earned ? "bg-[#FDF0EC]" : "bg-[#F4F8F5] opacity-50"}`} data-testid={`badge-${b.id}`}>
            {b.earned ? <Award className="h-6 w-6 text-[#E05C3A]" /> : <Lock className="h-6 w-6 text-[#7B968B]" />}
            <span className="mt-1 text-[10px] font-semibold leading-tight text-[#0D3B2B]">{t(b.name)}</span>
          </div>
        ))}
      </div>
      <Link to="/rewards" className="flex h-12 items-center justify-center gap-2 rounded-2xl bg-[#E05C3A] font-bold text-white" data-testid="points-rewards-link"><Gift className="h-5 w-5" />{t("Rewards store")}</Link>
      <p className="text-[11px] text-[#7B968B]">{t(d.how)} <Link to="/learn" className="font-semibold text-[#2E9E6B]" data-testid="points-learn-link">{t("Earn more in the quiz")}</Link></p>
    </Card>
  );
};
